import { CEPeriodBase } from './ce-period-base'


export class CEPeriod extends CEPeriodBase {

}